import { CircularProgress } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { HeaderSpacer } from '../components/Header';
import ListHeroPage from '../components/ListHeroPage';
import { selectContext } from '../redux/features/context/contextSlice';
import { fetchList } from '../redux/features/lists/listsSlice';
import StyledBackdrop from '../components/StyledBackdrop';
import Login from '../components/Login';

function ListUpdateView() {
  const { listId } = useParams();

  const dispatch = useDispatch();
  const context = useSelector(selectContext);
  const { userInfo } = useSelector((state) => state.users);

  const loadList = useCallback(
    () => dispatch(fetchList({ namespace: 'private', listId })),
    [dispatch, listId],
  );

  useEffect(() => {
    if (userInfo && listId) loadList();
  }, [loadList, userInfo, listId]);

  const listInfo = context && context.listInfo;

  return (
    <>
      <HeaderSpacer />
      { !userInfo && <Login />}
      { userInfo && !listInfo && (
        <StyledBackdrop open={!listInfo}>
          <CircularProgress color="inherit" />
        </StyledBackdrop>
      )}
      { userInfo && listInfo && (
        <ListHeroPage
          listInfo={listInfo}
          namespace="private"
          onRefetch={loadList}
          startInEdit
        />
      )}
    </>
  );
}

export default ListUpdateView;
